export default "__VITE_ASSET__be11bd4c__"